@if (dataIsLoaded) {
  <div>
    <ul class="list-group root-menu" [class.root-to-markets]="rootToMarkets" [class.back-to-root]="backToRoot">
      <li class="list-group-item logo-container">
        @if (isBaoying()) {
          <a href="/" data-automation="logo-mobile-home"
            ><img src="{{ 'assets/logo.png' }}" class="w-100" alt="Home"
          /></a>
        } @else {
          <a href="/" data-automation="logo-mobile-home"
            ><img src="{{ 'assets/USANA_logo_black.svg' }}" class="w-100" alt="Home"
          /></a>
        }
      </li>
      @for (item of data; track item) {
        @if (hasInnerText(item.name)) {
          <li class="list-group-item" [class.children]="item.children">
            <a
              uDcSRemoveUsanaPhSubdomainShop
              [attr.href]="item.url"
              (click)="handleLink($event, item.url, item.target)"
              attr.data-automation="{{ urlPathId(item.url) }}"
              target="{{ item.target }}"
              class="u-media"
            >
              {{ item.name }}
              @if (item.children) {
                <fa-icon [icon]="['fal', 'angle-right']"></fa-icon>
              }
            </a>
          </li>
        }
      }
      @if (!isBaoying()) {
        <li class="list-group-item selected-market">
          <button
            class="u-media align-items-center p-0"
            (click)="selectMarket()"
            data-automation="mobileSelectMarketButton"
          >
            <div class="media-body flex-grow-1">
              <div><small class="muted" [innerHTML]="current_market_locale.select_text"></small></div>
              <div class="u-media">
                <span class="flag-icon flag-icon-{{ current_market.flag }}"></span>
                <div class="media-body" [innerHTML]="market_name"></div>
              </div>
            </div>
            <fa-icon [icon]="['fal', 'angle-right']"></fa-icon>
          </button>
        </li>
      }
      <li class="list-group-item selected-market">
        @if (isLoggedIn()) {
          @if (['A', 'D', 'EM'].includes(customerType)) {
            <a [href]="hubUrl" data-automation="hub-link" class="btn btn-default">
              <span [innerHTML]="'the-hub' | i18n: 'usanadotcom'"></span>&nbsp;
            </a>
          } @else {
            <a href (click)="logout()" data-automation="hub-logout" class="btn btn-default">
              <span [innerHTML]="'logout' | i18n: 'usanadotcom'"></span>&nbsp;
            </a>
          }
        } @else {
          <a
            href="{{ hubUrl }}"
            (click)="goToHubOrLogin($event)"
            attr.data-automation="{{ 'hub-' + urlPathId(hubUrl) }}"
            class="btn btn-default"
            ><span [innerHTML]="'login' | i18n: 'usanadotcom'"></span>&nbsp;</a
          >
        }
      </li>
    </ul>
    <ul
      class="list-group market-list"
      [class.markets-to-languages]="marketsToLanguages"
      [class.back-to-markets]="backToMarkets"
    >
      <li class="list-group-item">
        <button class="u-media" (click)="backFromMarkets()">
          <fa-icon [icon]="['fal', 'angle-left']"></fa-icon>
          <div class="media-body">{{ current_market_locale.back_text }}</div>
        </button>
      </li>
      @for (item of markets; track item) {
        <li class="list-group-item">
          <button class="u-media" (click)="selectLanguages(item.name)">
            <span class="flag-icon flag-icon-{{ item.flag }} flex-shrink-0"></span>
            <div class="media-body flex-grow-1">{{ item.name }}</div>
            @if (item.languages) {
              <fa-icon [icon]="['fal', 'angle-right']"></fa-icon>
            }
          </button>
        </li>
      }
    </ul>
    <ul class="list-group language-list" #languagePickerMobile>
      <li class="list-group-item">
        <button class="u-media" (click)="backFromLanguages()">
          <fa-icon [icon]="['fal', 'angle-left']"></fa-icon>
          <div class="media-body">{{ current_market_locale.back_text }}</div>
        </button>
      </li>
      @for (item of selected_market.languages; track item) {
        <li class="list-group-item">
          <button class="u-media" (click)="setLocale(item.locale)">
            <div class="media-body">{{ item.language }}</div>
          </button>
        </li>
      }
    </ul>
  </div>
}
